export const parseReading = (value) => {
	if (value === null || value === undefined || value === "") {
		return null;
	}
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : null;
};

export const isMonthBasedUnit = (unitType) => unitType === "Month";

/** Hours and Kms only — month-based equipment uses scheduled dates, not usage records. */
export const isCounterBasedUnit = (unitType) =>
	unitType === "Hours" || unitType === "Kms";

export const supportsUsageRecording = (unitType) => isCounterBasedUnit(unitType);

export const calculateUnitsUsed = (startReading, endReading) => {
	const start = parseReading(startReading);
	const end = parseReading(endReading);
	if (start === null || end === null) {
		return null;
	}
	return end - start;
};

export const unitLabel = (unitType) => {
	if (unitType === "Kms") return "km";
	if (unitType === "Hours") return "hours";
	if (unitType === "Month") return "months";
	return "units";
};

export const readingLabel = (unitType, kind) => {
	const unit = unitType === "Kms" ? "km" : unitType === "Hours" ? "hours" : "reading";
	return kind === "end" ? `End ${unit}` : `Start ${unit}`;
};
